import { Card, Container, Ratio } from "react-bootstrap";

import { Back } from "@/ui/Back";
import cn from "classnames";
import { format } from "date-fns";
import Link from "next/link";
import { Parallax } from "react-scroll-parallax";
import classes from "./styles.module.scss";

export default function ({
  className,
  featured,
  title,
  topics,
  image,
  blog_header_image,
  published,
  author,
  EditableHtml,
  EditableImage,
  theme = "light",
}) {

  return (
    <Card className={cn(className, classes.BlogPostHero)} data-bs-theme={theme}>
      <Parallax translateY={[-80, 40]}>
        <Card.Img as={Ratio} aspectRatio={34}>
          <>
            {(blog_header_image || image) && (
              <EditableImage path="image" src={blog_header_image || image} size="1920x547" />
            )}
          </>
        </Card.Img>
      </Parallax>
      <Card.ImgOverlay className="d-flex flex-column text-center align-items-center justify-content-center pb-4 pb-md-5 pt-5">
        <Container fluid="md" className="pt-5 pb-md-5">
          <Back href="/blog" className="mb-4 mb-md-0">
            Back to Blog
          </Back>
          {featured && (
            <Card.Header className="small mb-4">
              <i /> Featured Blog
            </Card.Header>
          )}
          <Card.Title as={EditableHtml} path="title" tag="h1">
            <span dangerouslySetInnerHTML={{ __html: title }} />
          </Card.Title>
          <Card.Footer className="flex-column flex-md-row">
          {topics && topics.length > 0 && (
              <span>
                {topics.map((topic, index) => (
                  <span key={topic?.id || index}>
                    {topic?.name}
                    {index < topics?.length - 1 && ', '}
                  </span>
                ))}
              </span>
            )}
            <span className="d-none d-md-block">/</span>
            <span>
              <span>
                {Date.parse(published) ? format(new Date(published), "d MMM yyyy") : published}
              </span>
            </span>
            {author && (
              <>
                <span className="d-none d-md-block">/</span>
                <span>
                  {author.href ? (
                    <Link href={author.href} className={classes.author}>
                      {author.name}
                    </Link>
                  ) : (
                    author.name
                  )}
                </span>
              </>
            )}
          </Card.Footer>
        </Container>
      </Card.ImgOverlay>
    </Card>
  );
}
